export default __webpack_public_path__ + "static/media/arrow-left.d9daa76b.svg";